import React, { useState } from 'react'
import axios from 'axios'
import { Button, Col, Space, Breadcrumb, Form } from 'antd'
import {
  getHeaders,
  successNotification,
  errorNotification,
  adminUsersUrl
} from '../../config'
import BasicInput from '../../components/Forms/BasicInput'
import PageTitle from 'components/PageTitle'

const CustomerForm = props => {
  const [customer, setCustomer] = useState({
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: ''
  })

  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleInputChange = stateName => event => {
    setCustomer({ ...customer, [stateName]: event.target.value })
  }

  const handleSubmit = event => {
    event.preventDefault()
    setLoading(true)
    axios
      .post(adminUsersUrl, customer, {
        headers: getHeaders()
      })
      .then(() => {
        setLoading(false)
        // eslint-disable-next-line react/prop-types
        props.history.push('/customers')
        successNotification('New Customer Added')
      })
      .catch(err => {
        setLoading(false)
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error adding customer, retry.')
      })
  }

  return (
    <div className="container">
      <PageTitle title="New customer" />
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              {/* <HomeOutlined /> */}
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/customers">Our Customers</Breadcrumb.Item>
            <Breadcrumb.Item>New Customer</Breadcrumb.Item>
          </Breadcrumb>
          <br />
          <br />
          <div className="card mb-4rem">
            <div className="card-header">Add New Customer</div>
            <div className="card-body">
              <Form className="p-2rem" layout="vertical">
                <div className="row">
                  <div className="col-md-5">
                    <BasicInput
                      label="First Name"
                      value={customer.firstName}
                      name={'first name'}
                      placeholder="first name"
                      handleChange={handleInputChange('firstName')}
                      required={false}
                    />
                    {serverErrors.firstName &&
                      serverErrors.firstName.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5 offset-md-2 offset-sm-0 ">
                    <BasicInput
                      label="Last Name"
                      value={customer.lastName}
                      name={'last name'}
                      placeholder="last name"
                      handleChange={handleInputChange('lastName')}
                      required={false}
                    />

                    {serverErrors.lastName &&
                      serverErrors.lastName.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Email"
                      value={customer.email}
                      name={'email'}
                      placeholder="email"
                      handleChange={handleInputChange('email')}
                      required={false}
                    />
                    {serverErrors.email &&
                      serverErrors.email.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5 offset-md-2 offset-sm-0">
                    <BasicInput
                      label="Phone Number"
                      value={customer.phoneNumber}
                      name={'phone'}
                      placeholder="phone number"
                      handleChange={handleInputChange('phoneNumber')}
                      required={true}
                    />
                    {serverErrors.phoneNumber &&
                      serverErrors.phoneNumber.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  {serverErrors.nonFieldErrors &&
                    serverErrors.nonFieldErrors.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}

                  <Col md={24}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        marginBottom: '20px'
                      }}
                    >
                      <Space>
                        {/* eslint-disable-next-line react/prop-types */}
                        <Button onClick={() => props.history.goBack()}>
                          Go Back
                        </Button>
                        <Button
                          type="primary"
                          onClick={handleSubmit}
                          loading={loading}
                        >
                          Submit
                        </Button>
                      </Space>
                    </div>
                  </Col>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerForm
